import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../api/actions";

export default function ProtectedRoutes() {
  const auth = useAuth();
  return auth ? <Outlet /> : <Navigate to="/signin" />;
}
